module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Roulette-1e3e970bd4407c75797d6f6506f6201a.svg";